import { useSearchParams } from "react-router-dom";

// قاعدة ذهبية: يحفظ التبويب/العرض النشط في عنوان URL (?view=…) لتبقى الصفحة كما هي عند الـ Refresh.
export const useUrlTab = (defaultValue, paramKey = "view") => {
  const [params, setParams] = useSearchParams();
  const current = params.get(paramKey) || defaultValue;
  const setValue = (v) => {
    const next = new URLSearchParams(params);
    if (!v || v === defaultValue) next.delete(paramKey);
    else next.set(paramKey, v);
    setParams(next, { replace: false });
  };
  return [current, setValue];
};
